import { createElement } from 'react';
import toast from 'react-hot-toast';

/**
 * Uitgesteld uitvoeren met terughaalknop (Gmail-stijl "verzenden ongedaan maken").
 *
 *   const r = await voerUitgesteldUit('Mail wordt verzonden…', () => verstuur(), { duur: 5000 });
 *   if (r.geannuleerd) { … er is niets gebeurd … } else { … r.resultaat of r.fout … }
 *
 * Voor acties die naar buiten gaan (mail, klant, Frame.io, Gripp) en te vaak voorkomen voor
 * een bevestigingsvraag: de actie start pas ná `duur` ms, en tot die tijd staat er een
 * melding met "Annuleren". Verlaat de gebruiker de pagina, dan gaat de actie alsnog direct
 * door (beforeunload) zodat er niets stil verloren gaat.
 */
export function voerUitgesteldUit(tekst, actie, { duur = 5000, klaarTekst } = {}) {
  return new Promise((resolve) => {
    let afgerond = false;
    let timer = null;
    const id = `uitgesteld-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

    const nu = () => { rond(false); };
    const rond = async (geannuleerd) => {
      if (afgerond) return;
      afgerond = true;
      clearTimeout(timer);
      window.removeEventListener('beforeunload', nu);
      toast.dismiss(id);
      if (geannuleerd) {
        toast('Geannuleerd', { icon: '↩️', duration: 2500 });
        resolve({ geannuleerd: true });
        return;
      }
      try {
        const resultaat = await actie();
        if (klaarTekst) toast.success(klaarTekst);
        resolve({ geannuleerd: false, resultaat });
      } catch (e) {
        toast.error(e?.message || 'Mislukt');
        resolve({ geannuleerd: false, fout: e });
      }
    };

    toast((t) => createElement('span', { style: { display: 'inline-flex', alignItems: 'center', gap: 12 } },
      tekst,
      createElement('button', {
        onClick: () => rond(true),
        style: { border: 0, background: '#1e3a8a', color: '#fff', borderRadius: 6, padding: '4px 10px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
      }, 'Annuleren')), { id, duration: duur + 500, icon: '⏳' });

    timer = setTimeout(() => rond(false), duur);
    window.addEventListener('beforeunload', nu);
  });
}

export default voerUitgesteldUit;
